















import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'

@Component
export default class ComponentBackofficeInformacoesSobreOrcamento extends Vue {
  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }
}
